<template>
    <b-spinner v-if="!apps"/>
    <div v-else>
        <b-row>
            <b-col cols="12" class="mb-4">
                <b-row>
                    <b-col cols="3" md="1"><b-button block variant="success" @click="$router.push(`/admin/components/create?type=app`)">{{ $t('add') }}</b-button></b-col>
                    <b-col cols="3" md="1"><b-button block variant="warning" @click="$router.push(`/app/playground`)">Playground</b-button></b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="3" v-for="app in apps" :key="app.uuid">
                <b-card class="publicapp" @click="$router.push(`/admin/app/settings/${app.uuid}`)">
                    <b-card-header>{{ app.name }}</b-card-header> 

                    <br />
                    <b-icon icon="wrench"></b-icon> <small> {{ app.dev_version || "not active" }}</small>
                    <br />
                    <b-icon icon="people"></b-icon>  <small> {{ app.public_version || "not live" }}</small>
                </b-card>
            </b-col>
        </b-row>

        <span v-if="apps.length < 1">{{ $t('noApps') }}. </span>
    </div>
    
</template>
<script>
export default {
    name: 'List',
    components: { },
    data: function() {
        return {
            apps: null,
            fields: ["name"]
        }
    },
    methods: {
        goToApp(item) {
            this.$router.push("/app/" + item.uuid)
        },

        stageHostname(app) {
            let parts = app.base_hostname.split(".")

            parts.splice(1, 0, 'stage')

            return parts.join(".")
        },
    },
    mounted() {
       if (!this.$isAdmin()) {
            return this.$router.back();
       }

       this.$http.get("/v3/system/gateway/app-service/app/all").then(resp => {
            this.apps = resp.data || []
       }).catch(err => {
           this.$debugLog(err)
           this.$bvModal.msgBoxOk("Failed to fetch apps.")
       })
    }
}
</script>

<style scoped>
.publicapp {
    cursor: pointer;
}
</style>
